<template>
<v-container>
    <v-row>
        <ProjectCard v-for="project in projects" :key="project.id" :project="project" />
    </v-row>
</v-container>
</template>

<script>
import ProjectCard from "@/components/ProjectCard";
import { projects } from "./../projects.js";

export default {
    components: {
        ProjectCard
    },
    data() {
        return { 
            projects: null,
        }
    },
    mounted() {
        this.projects = projects;
    }
}
</script>